import { NavBar } from 'components/NavBar/NavBar'
import { setConfirmModal } from 'features/global/globalSlice'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
    Button,
    Flex,
    MainHeadline,
    PageFooter,
    PageWrapper,
    Table,
    Th,
    Tr,
} from 'styling/GlobalStyles'
import { Pagination } from 'components/Pagination/Pagination'
import { formatNumbersForDisplay, getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { TanksModal } from './TanksModal'
import { clearTanks, deleteFuelTank, getFuelTanks } from 'features/fuelManagement/fuelManagementSlice'
import { Td } from 'components/Td/Td'
import { Options } from 'components/Options/Options'

export const FuelTanks = () => {
    const [modal, setModal] = useState({ open: false, value: null })
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location }))
    const { tanks } = useSelector((store: RootState) => store.fuelManagement)

    useQueryPagination({ fetchFunctions: [getFuelTanks], cleanUpFunctions: [clearTanks], params })

    const handleRemove = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteFuelTank(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: tanks.data.length < 2,
                },
                word: 'delete tank',
            }),
        )
    }

    return (
        <>
            <PageWrapper>
                <NavBar defaultValue={params.q} input placeholder='Search Fuel Tanks...' setParams={setParams} />
                <Flex between mb='16' >
                    <MainHeadline>Fuel Tanks</MainHeadline>
                    <Button orange onClick={() => setModal({ open: true, value: null })}>
                        Add Tank
                    </Button>
                </Flex>
                {!tanks?.data?.length ? (
                    <NoItems title='Fuel Suppliers' />
                ) : (
                    <Table width='100%' >
                        <Th next>
                            <Td w='19%' noTooltip text='NAME' />
                            <Td w='19%' noTooltip text='CAPACITY' />
                            <Td w='19%' noTooltip text='CURRENT AMOUNT' />
                            <Td w='19%' noTooltip text='SENSOR' />
                            <Td w='19%' noTooltip text='CURRENT AMOUNT VIA SENSOR' />
                            <Td w='5%' noTooltip />
                        </Th>
                        {tanks?.data.map((item) => {
                            return (
                                <Tr key={item.id}>
                                    <Td w='19%' text={item.name || '/'} />
                                    <Td w='19%' text={formatNumbersForDisplay(item.capacity) || '/'} />
                                    <Td w='19%' text={formatNumbersForDisplay(item.currentAmount) || '/'} />
                                    <Td w='19%' text={item.sensor?.label || '/'} />
                                    <Td w='19%' text={item.currentSensorAmount ? formatNumbersForDisplay(item.currentSensorAmount) : '/'} />
                                    <Td options w='5%' >
                                        <Options item={item} title='Fuel Tanks' handleRemove={handleRemove} openModal={() => setModal({ open: true, value: item })} />
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Table>
                )}


            </PageWrapper>
            {modal.open &&
                <TanksModal value={modal.value} closeModal={() => setModal({ value: null, open: false })} />
            }
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams)}
                    pageCount={Math.ceil(tanks.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
